import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchWeeklyInformation, createWeeklyInformation, updateWeeklyInformation } from './actions';
import WeeklyInformationSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';
import { getActiveLanguage } from '../../languages/reducer';
import { withTranslation } from 'react-i18next';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleWeeklyInformationSettingsSubmit = this.handleWeeklyInformationSettingsSubmit.bind(this);
	}

	componentDidMount() {

		this.loadGrades();
		this.reloadData();
	}

	reloadData() {
		const { match, fetchWeeklyInformation } = this.props;
		const weeklyInformationId = match.params.id;

		if (weeklyInformationId) {
			fetchWeeklyInformation(weeklyInformationId);
		}
	}

	handleWeeklyInformationSettingsSubmit(values) {
		const { weeklyInformation, createWeeklyInformation, updateWeeklyInformation, history } = this.props;

		if (weeklyInformation) {
			updateWeeklyInformation(weeklyInformation.id, values);
		} else {
			createWeeklyInformation(values, history);
		}
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	render() {
		const { weeklyInformation, isReadonly, gradesList, lang, t } = this.props;
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<WeeklyInformationSettingsForm isReadonly={isReadonly} onSubmit={this.handleWeeklyInformationSettingsSubmit} initialValues={weeklyInformation} grades={gradesList} lang={lang} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const weeklyInformationId = ownProps.match.params.id;

	const {
		entities: { weeklyInformations, grades },
		auth: { currentUser }
	} = state;

	return {
		weeklyInformation: weeklyInformations[weeklyInformationId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WeeklyInformations'),
		gradesList: grades,
		lang: getActiveLanguage(state.configuration.language)
	};
};

export default connect(mapStateToProps, {
	fetchWeeklyInformation,
	createWeeklyInformation,
	updateWeeklyInformation,
	loadUnpagedGrades,
})(withTranslation()(Details));